import BurgerMenuTitle from "../../Component/BurgerMenuTitle/BurgerMenuTitle"
import DeliveryBottomNavigation from "./components/DeliveryBottomNavigation/DeliveryBottomNavigation"
import DeliveryTabs from "./components/DeliveryTab/DeliveryTab"

const DeliveryLayout = () => {

  return (
    <div style={{padding:'2.5rem 0'}}>
      <BurgerMenuTitle title={"پیک"} />
      <DeliveryTabs/>
      <DeliveryBottomNavigation/>
    </div>
  )
}

export default DeliveryLayout